module.exports = __webpack_public_path__ + "static/img/tow.5f7ea59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manyRecruitImg/tow.png
// module id = /eCp
// module chunks = 1